module.exports = function() {
  return new Worker(__webpack_public_path__ + "9403de0f324740188b48.worker.js");
};